import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'
import DetectBrowser from 'detect-browser'
import vueHeadful from 'vue-headful'
import axiosRetry from 'axios-retry'
import VueClipboard from 'vue-clipboard2'
import Toasted from 'vue-toasted'
import App from './App.vue'
import VueUploadComponent from 'vue-upload-component'
import * as VueGoogleMaps from 'vue2-google-maps'
import WebCam from 'vue-web-cam';

Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(VueClipboard)
Vue.use(WebCam)
Vue.component('vue-headful', vueHeadful)
Vue.component('file-upload', VueUploadComponent)

Vue.use(Toasted, {
    position: 'top-right',
    duration: 3000,
    fullWidth: false,
    closeOnSwipe: true,
});

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyBIQXzcdQgAsNkYlxLhcGM8lRkaLLKXLcs',
        libraries: 'places,geometry'
    }
})

axiosRetry(axios, {
    retries: 3,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: retryCondition
});

// for the axios retry package, only retry if the status isn't 503 (503 is used for hitting limit)
function retryCondition(error) {

    if (error.response.status == 503) {
        return false;
    }

    if (error.response.status == 504) {
        return true;
    }

    // default response
    return axiosRetry.isNetworkError(error) || axiosRetry.isIdempotentRequestError(error);
}

import InputPhone from './components/InputPhone.vue'
import InputDateOfBirth from './components/InputDateOfBirth.vue'
import InputExpiry from './components/InputExpiry.vue'
import InputBase from './components/InputBase.vue'
import Countdown from './components/Countdown.vue'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import RateHoldTimer from './components/RateHoldTimer.vue'
import Modal from './components/Modal.vue'
import QuoteExpired from './components/QuoteExpired.vue'
import VueMoment from 'vue-moment';
import moment from 'moment-timezone';

Vue.component('input-phone', InputPhone)
Vue.component('input-date-of-birth', InputDateOfBirth)
Vue.component('input-expiry', InputExpiry)
Vue.component('input-base', InputBase)
Vue.component('cc-header', Header)
Vue.component('cc-footer', Footer)
Vue.component('cc-rate-hold-timer', RateHoldTimer)
Vue.component('cc-countdown', Countdown)
Vue.component('cc-modal', Modal)
Vue.component('cc-quote-expired', QuoteExpired)

Vue.use(VueMoment, {
    moment,
});

Object.defineProperty(Vue.prototype, '$browser', { value: DetectBrowser });

import routes from './helpers/routes.js'
const router = new VueRouter({
    routes
})

Vue.config.productionTip = false

router.beforeEach(function(to, from, next) {
    window.scrollTo(0, 0);
    next();
});

Vue.filter('num2decimal', function(value) {
    if (!value) return ''

    // insert comma for long numbers
    var parts = Number.parseFloat(value).toFixed(2).toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // if value is huge, do not do 2 decimals
    if (value > 100000) return parts[0]

    return parts.join(".");
})

Vue.filter('num8decimal', function(value) {
    if (!value) return ''
    return Number.parseFloat(value).toFixed(8);
})

import gstate from './helpers/global-state.js'
Vue.prototype.$gstate = gstate;
Vue.prototype.noop = function() {};

const isProd = process.env.NODE_ENV === "production"
Vue.use(VueAnalytics, {
    id: 'UA-125394282-1',
    checkDuplicatedScript: true,
    router,
    debug: {
        enabled: false, // !isProd, // do not want the debug enabled
        sendHitTask: isProd
    }
})

function EnableLeaveNotification() {
    window.onbeforeunload = function() {
        return "Are you sure?"; // doesn't actually display but function needs to return something or it doesn't work
    }
}

function DisableLeaveNotification() {
    window.onbeforeunload = null;
}

export const eventBus = new Vue();

var configName = 'config.json';
if (window.location.hostname.includes('secure.coincurve.com')) {
    configName = 'config-prod-coincurve.json';
} else if (window.location.hostname.includes('zero.coincurve.com')) {
    configName = 'config-prod-zero.json';
} else if (window.location.hostname.includes('buy.supereasybitcoin.com')) {
    configName = 'config-prod-supereasybitcoin.json';
} else if (window.location.hostname.includes('buy.localcoin.ca')) {
    configName = 'config-prod-localcoin.json';
} else if (window.location.hostname.includes('secure.ibankdigital.io')) {
    configName = 'config-prod-ibank.json';
} else if (window.location.hostname.includes('eft.bitcoinwell.com')) {
    configName = 'config-prod-bitcoinsolutions.json';
} else if (window.location.hostname.includes('secure.neutronbase.io')) {
    configName = 'config-prod-neutron.json';
} else if (window.location.hostname.includes('canada.gocoinstream.com')) {
    configName = 'config-prod-coinstream.json';
} else if (window.location.hostname.includes('test')) {
    configName = 'config-test.json';
} else if (window.location.hostname.includes('localcoindev')) {
    configName = 'config-dev-localcoin.json';
} else if (window.location.hostname.includes('ibankdev')) {
    configName = 'config-dev-ibank.json';
} else if (window.location.hostname.includes('coinstreamdev')) {
    configName = 'config-dev-coinstream.json';
} else if (window.location.hostname.includes('bitcoinsolutionsdev')) {
    configName = 'config-dev-bitcoinsolutions.json';
} else if (window.location.hostname.includes('neutrondev')) {
    configName = 'config-dev-neutron.json';
} else if (window.location.hostname.includes('dev')) {
    configName = 'config-dev.json';
}

axios.get("static/js/" + configName)
    .then(response => {
        Vue.prototype.$gstate.saveConfig(response.data);
        startVue();
    })
    // eslint-disable-next-line
    .catch(error => {
        Vue.prototype.$gstate.redirectHome(300, 0, 'error fetching config');
    });

function startVue() {

    const app = new Vue({
        router: router,
        el: '#app',
        render: h => h(App),
        methods: {
            handleGlobalKeyDown(e) {
                // detect enter key press
                if (e.keyCode == 13) {
                    eventBus.$emit('nextScreen');
                }
            },
            EnableLeaveNotification() {
                EnableLeaveNotification();
            },
            DisableLeaveNotification() {
                DisableLeaveNotification();
            }
        }
    })

    // global event listener for debug
    window.addEventListener('keydown', function(e) {
        app.handleGlobalKeyDown(e);
    });

    // tag manager
    if (Vue.prototype.$gstate.getGTM() != undefined) {
        Vue.use(VueGtm, {
            id: Vue.prototype.$gstate.getGTM(), // Your GTM ID
            enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
            debug: false, // Whether or not display console logs debugs (optional)
            vueRouter: router, // Pass the router instance to automatically sync with router (optional)
        });
    }
}